var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489",
    transform: "translate(377 -4833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1591",
    "data-name": "Rectangle 1591",
    width: 15,
    height: 15,
    transform: "translate(-377 4833)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M526.068,22.383h-3.209V20.742a.568.568,0,0,0-.549-.586h-4.388a.568.568,0,0,0-.548.586v1.641h-3.209a.587.587,0,0,0,0,1.172h1.014V34.57a.568.568,0,0,0,.548.586H524.5a.568.568,0,0,0,.549-.586V23.554h1.015a.587.587,0,0,0,0-1.172Zm-7.6-1.055h3.291v1.055h-3.291Zm5.485,12.656h-7.679V23.554h7.679ZM519.2,25.2v7.148a.55.55,0,1,1-1.1,0V25.2a.55.55,0,1,1,1.1,0Zm2.926,0v7.148a.55.55,0,1,1-1.1,0V25.2a.55.55,0,1,1,1.1,0Z",
    transform: "translate(-889.616 4812.844)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.30bd6efb10adc0b00d4f3117cb54dae1.svg";
export { ForwardRef as ReactComponent };